import script from "./message-video-web.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-video-web.vue?vue&type=script&lang=ts&setup=true"

import "./message-video-web.vue?vue&type=style&index=0&id=7b98bae8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b98bae8"]])

export default __exports__